import type { PublicSkillGroup } from '../types';
import { Reveal, RevealGroup } from './Reveal';

export function Skills({ groups }: { readonly groups: readonly PublicSkillGroup[] }) {
  if (groups.length === 0) {
    return null;
  }

  return (
    <RevealGroup className="grid gap-2">
      {groups.map((group) => (
        <Reveal key={group.id} className="entry-row">
          <h3 className="mt-[5px] mb-0 text-[11px] font-semibold uppercase tracking-label text-faint">
            {group.name}
          </h3>

          <ul className="m-0 grid list-none gap-2 p-0">
            {group.items.map((item) => (
              <li key={item} className="flex items-baseline gap-[11px] text-[14.5px]">
                <span
                  aria-hidden="true"
                  className="size-1 flex-none rounded-full bg-line-strong"
                />
                {item}
              </li>
            ))}
          </ul>
        </Reveal>
      ))}
    </RevealGroup>
  );
}
